import { ColumnDef } from '@tanstack/react-table';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { DELETE_JOB_TYPE, JobType } from 'services/api/jobTypes';
import JobTypeModal from 'components/modals/JobTypeModal';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
const handleDelete = async (typeId: string) => {
  try {
    const response = await DELETE_JOB_TYPE(typeId);

    if (response?.status === 200) {
      toast.success('Job Type deleted successfully');
    } else {
      throw new Error('Failed to delete job type');
    }
  } catch (error: any) {
    console.error('Error deleting job type:', error);
    toast.error(error.response?.data?.message || 'Error deleting job type');
  }
};

export const jobTypesColumns = (
  canEdit = false,
  canDelete = false
): ColumnDef<JobType>[] => {
  return [
    {
      accessorKey: 'name',
      header: 'Job Type',
      cell: ({ row: { original } }) => {
        const name = original.name;
        return <div className="d-flex align-items-center">{name}</div>;
      },
      meta: {
        headerProps: { style: { width: '25%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'description',
      header: 'Description',
      cell: ({ row: { original } }) => {
        const description = original.description;
        return (
          <div className="d-flex align-items-center">
            <div>
              <Link to="" className="fs-8 fw-bold">
                {description}
              </Link>
            </div>
          </div>
        );
      },
      meta: {
        headerProps: { style: { width: '25%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'createdAt',
      header: 'Created At',
      cell: ({ row: { original } }) => {
        const createdAt = original.createdAt;
        return (
          <div className="d-flex align-items-center">
            {dayjs(createdAt).format('DD/MM/YYYY')}
          </div>
        );
      },
      meta: {
        headerProps: { style: { width: '25%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      accessorKey: 'updatedAt',
      header: 'Updated At',
      cell: ({ row: { original } }) => {
        const updatedAt = original.updatedAt;
        return (
          <div className="d-flex align-items-center">
            {dayjs(updatedAt).format('DD/MM/YYYY')}
          </div>
        );
      },
      meta: {
        headerProps: { style: { width: '25%' }, className: 'ps-0' },
        cellProps: { className: 'white-space-nowrap ps-0' }
      }
    },
    {
      id: 'leadDropdown',
      cell: ({ row: { original } }) => {
        const jobTypeId = (original as any).id || original._id;
        const navigate = useNavigate();
        const queries = useQueryClient();
        const [showModal, setShowModal] = useState(false);

        const handleDeleteClick = async (jobTypeId: string) => {
          try {
            await handleDelete(jobTypeId);
            queries.invalidateQueries('getJobTypes');
            navigate('/home/apps/job-types/create-a-job-type');
          } catch (error) {
            console.error('Error handling delete:', error);
          }
        };

        if (!canEdit && !canDelete) {
          return null;
        }
        return (
          <>
            <RevealDropdownTrigger>
              <RevealDropdown>
                <>
                  {canEdit && (
                    <Dropdown.Item
                      eventKey="2"
                      onClick={() => setShowModal(true)}
                    >
                      Edit
                    </Dropdown.Item>
                  )}
                  {canDelete && (
                    <>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        eventKey="4"
                        className="text-danger"
                        onClick={() => handleDeleteClick(jobTypeId as string)}
                      >
                        Delete
                      </Dropdown.Item>
                    </>
                  )}
                </>
              </RevealDropdown>
            </RevealDropdownTrigger>

            {showModal && (
              <JobTypeModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                isEditing
                jobType={original}
              />
            )}
          </>
        );
      },
      meta: {
        cellProps: {
          className: 'text-end pe-0 ps-4'
        }
      }
    }
  ];
};
